import Backbone from 'backbone';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

export const NavManagerModel = Backbone.Model.extend({
    urlRoot: '/api/facade_navigation_site/',
    defaults: {
        uuid: null,
        name: null,
        propertyUuid: null,
        navMain: null,
        navQuick: null,
        navInfo: null,
        navMobile: null,
    },
    blacklist: ['id'],
    initialize() {
        this.idAttribute = 'propertyUuid';
        bindAllMethods(this);
    },
    parse(data) {
        const model = data && (Array.isArray(data) && data.length > 0) ? data[0] : data;

        if (model && model.response) {
            delete model.response;
        }

        return model;
    },
    setMainNav(displayName, children) {
        this.set({
            navMain: {
                displayName,
                children,
            },
        });
    },
    setQuickNav(displayName, children) {
        this.set({
            navQuick: {
                displayName,
                children,
            },
        });
    },
    setInfoNav(displayName, children) {
        this.set({
            navInfo: {
                displayName,
                children,
            },
        });
    },
    setMobileNav(displayName, children) {
        this.set({
            navMobile: {
                displayName,
                children,
            },
        });
    },
    getGlobal(){
        if (typeof window !== 'undefined') {
            return window;
        }
        if (typeof global !== 'undefined') {
        // eslint-disable-next-line no-undef
            return global;
        }
        if (typeof globalThis !== 'undefined') {
        // eslint-disable-next-line no-undef
            return globalThis;
        }
        throw new Error('unable to find global context');
    },
    getSbgModules() {
        const globalContext = this.getGlobal();
        if (typeof globalContext.__sbgModules === 'undefined') {
            throw new Error('sbgModules has not yet been defined, unable to return');
        }

        return globalContext.__sbgModules;
    },
    getFQPFromSections(sectionList) {
        return sectionList.reduce(
            (list, section) => {
                const subsections = section.subsections;
                const fqp = section.fullyQualifiedPath.replace(this.domain, '');
                if (subsections.length === 0) {
                    return list.concat([fqp]);
                }
                return list.concat([
                    fqp,
                    ...this.getFQPFromSections(subsections),
                ]);
            },
            []
        );
    },
});

export default NavManagerModel;
